import React from 'react'
import {View} from 'react-native'
import {msg, Trans} from '@lingui/macro'
import {useLingui} from '@lingui/react'
import {useFocusEffect} from '@react-navigation/native'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {useSetMinimalShellMode} from '#/state/shell'
import {ViewHeader} from '#/view/com/util/ViewHeader'
import {CenteredView} from '#/view/com/util/Views'
import * as SettingsList from '#/screens/Settings/components/SettingsList'
import {atoms as a, useTheme} from '#/alf'
import {Newspaper_Stroke2_Corner2_Rounded as Newspaper} from '#/components/icons/Newspaper'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'
import {findCategory} from '#/content/help'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'HelpCategory'>
export const HelpCategoryScreen = ({route}: Props) => {
  const {_} = useLingui()
  const t = useTheme()
  const setMinimalShellMode = useSetMinimalShellMode()
  const category = findCategory(route.params.category)

  useFocusEffect(
    React.useCallback(() => {
      setMinimalShellMode(false)
    }, [setMinimalShellMode]),
  )

  if (!category) {
    return (
      <Layout.Screen>
        <ViewHeader title={_(msg`Help`)} />
        <CenteredView>
          <View style={[a.px_xl, a.pt_xl]}>
            <Text style={[{fontSize: 16}, t.atoms.text_contrast_medium]}>
              <Trans>Category not found.</Trans>
            </Text>
          </View>
        </CenteredView>
      </Layout.Screen>
    )
  }

  return (
    <Layout.Screen>
      <ViewHeader title={category.title} />
      <CenteredView>
        <View style={[a.px_xl, a.pt_xl, a.pb_md]}>
          <Text
            style={[
              {fontSize: 16, lineHeight: 24},
              t.atoms.text_contrast_medium,
            ]}>
            {category.description}
          </Text>
        </View>
        <View style={[a.pb_2xl]}>
          <SettingsList.Container>
            {category.articles.map(article => (
              <SettingsList.LinkItem
                key={article.slug}
                to={`/support/${category.slug}/${article.slug}`}
                label={article.title}>
                <SettingsList.ItemIcon icon={Newspaper} />
                <SettingsList.ItemText>{article.title}</SettingsList.ItemText>
              </SettingsList.LinkItem>
            ))}
          </SettingsList.Container>
        </View>
      </CenteredView>
    </Layout.Screen>
  )
}
